module.exports = __webpack_public_path__ + "img/value-2.a16250f8.png";